<template>
    <div class="container-fluid">
        <div v-if="$can('requests create')" class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{$t('requests.'+mode+'.title')}}</div>
                    <div class="card-body">
                        <form-request
                            :mode="mode"
                            :orderid="orderid"
                            :context="context"
                            @object-created="onObjectCreated"
                        ></form-request>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('requests create')">{{$t('access-denied')}}</h1>
    </div>
</template>

<script>
export default {
    name: "request-create",
    props: {
        user: [String, Number],
        mode: {
            type: String,
            default: 'create'
        },
        orderid: [Number, Boolean],
        context:[String],
        rmsobjectid:[Number],
        customerid:[Number]
    },
    mounted() {
        console.log("request-create loaded", this.mode, this.context);
    },
    methods:{
        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag angelegt wurde
         */
        onObjectCreated:function(){
            swal.fire({
                title: this.$t("requests.request-created-title"),
                text: this.$t("requests.request-created-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                this.handleBack('requests-grid', true, {reload: true});
            });
        },
    }
}
</script>

<style scoped>

</style>
